import { PlaycastKeyDetail } from '@playcastdotio/CoreTypes';
import { generators } from '@playcastdotio/Messaging';
import { getIpcMessagingInterface } from '../../messaging/protocols';

let afkInterval: NodeJS.Timeout | null = null;
let isEnabled = false;
let currentSettings = {
  enabled: false,
  keyCode: 32,
  intervalSeconds: 30,
  keyDisplayName: 'Space',
};

const createKeyDetail = (keyCode: number, keyDisplayName: string): PlaycastKeyDetail => {
  return {
    keyCode,
    location: 'standard',
    source: {
      type: 'keyboard',
      code: keyCode,
    },
    modifiers: {
      ctrl: false,
      alt: false,
      shift: false,
      meta: false,
    },
    displayName: keyDisplayName.toLowerCase(),
  };
};

const sendKeyPress = (keyCode: number, keyDisplayName: string) => {
  const keyDetail = createKeyDetail(keyCode, keyDisplayName);
  const messaging = getIpcMessagingInterface();

  // Use the experimental keyboard generators for host-side key simulation
  const keyDownMessage = generators.keyboard.down('host', keyDetail);
  const keyUpMessage = generators.keyboard.up('host', keyDetail);

  messaging.send(keyDownMessage);

  // Release the key after 50ms
  setTimeout(() => {
    messaging.send(keyUpMessage);
  }, 50);

  console.log(`[AFK Prevention] Sent key press: ${keyDisplayName} (${keyCode})`);
};

const startAfkPrevention = () => {
  if (afkInterval) {
    clearInterval(afkInterval);
  }

  if (isEnabled && currentSettings.enabled) {
    afkInterval = setInterval(() => {
      sendKeyPress(currentSettings.keyCode, currentSettings.keyDisplayName);
    }, currentSettings.intervalSeconds * 1000);

    console.log(`[AFK Prevention] Started with ${currentSettings.keyDisplayName} every ${currentSettings.intervalSeconds} seconds`);
  }
};

const stopAfkPrevention = () => {
  if (afkInterval) {
    clearInterval(afkInterval);
    afkInterval = null;
    console.log('[AFK Prevention] Stopped');
  }
};

export const setAfkPreventionEnabled = (enabled: boolean) => {
  isEnabled = enabled;
  currentSettings.enabled = enabled;

  if (enabled) {
    startAfkPrevention();
  } else {
    stopAfkPrevention();
  }
};

export const setAfkPreventionSettings = (settings: typeof currentSettings) => {
  currentSettings = { ...settings };

  // Restart with new settings if enabled
  if (isEnabled && settings.enabled) {
    startAfkPrevention();
  }
};

export const testAfkPreventionKey = (keyCode: number, keyDisplayName: string) => {
  sendKeyPress(keyCode, keyDisplayName);
};

// Clean up interval when module is unloaded
if (typeof window !== 'undefined') {
  window.addEventListener('beforeunload', () => {
    stopAfkPrevention();
  });
}
